<template>
  <div :class="treeClass" role="list">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, mixins } from "vue-facing-decorator";
import ServicedMixin from "@/components/field-element";
import { PropOptions } from "vue";

@Component({
  name: "cat-tree",
  mixins: [ServicedMixin]
})
export default class CatTree extends Vue {
  @Prop({ type: Boolean }) readonly section?: boolean;

  @Prop({
    type: String,
    description: "List of classes to be set in the box heading component."
  } as PropOptions<any>)
  public readonly headingClasses?: Array<string>;
  get treeClass(): object {
    return {
      "cat-tree": true
    };
  }
}
</script>
